import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import config from 'config';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import useWorkshopQuery from 'hooks/useWorkshopQuery';

async function update(
  axios: AxiosInstance,
  submissionData: {
    workshop_id: number;
    trial_ends_at: string;
  },
): Promise<object> {
  const data = await axios.put(`${config.apiBaseUrl}/op/v1/subscription/extend-free-trial`, submissionData);
  return data;
}

export default function useFreeTrialMutation({ workshop_id }: { workshop_id: number }) {
  const queryClient = useQueryClient();
  const axios = useAxios();
  const toast = useToast();
  return useMutation({
    mutationKey: ['free-trial'],
    mutationFn: ({ trial_ends_at }: { trial_ends_at: string }) => update(axios, { workshop_id, trial_ends_at }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: useWorkshopQuery.getKey(workshop_id),
      });
    },
    onError: (error: any) => {
      manageErrorResponse(toast, error.response.data);
    },
  });
}
